import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  
}, km({
    RECOMMEND_GET_HOT_BANNER_EMPTY: null,
    RECOMMEND_GET_HOT_BANNER_SUCCESS: null,
    RECOMMEND_GET_HOT_BANNER_ERROR: null,

    RECOMMEND_GET_HOT_PRODUCT_EMPTY: null,
    RECOMMEND_GET_HOT_PRODUCT_SUCCESS: null,
    RECOMMEND_GET_HOT_PRODUCT_ERROR: null,
    RECOMMEND_GET_HOT_PRODUCT_MORE_SUCCESS: null,
}))
